import { z } from 'zod'
import { FeedEventSource, MemberEventSource } from '../segment.types'

export const memberNotesOpenedSchema = z.object({
  masterTaskId: z.string().optional(),
  source: z.enum([FeedEventSource.CHART, FeedEventSource.SIDEBAR, MemberEventSource.MEMBER_PROFILE, MemberEventSource.MEMBERS_LIST]),
})
